import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { loaderStateTrue, loaderStateFalse } from '../../slices/mainSlice';
import { useDispatch } from 'react-redux';
import { coachRegisterApi, getTeamListApi } from '../Controller/LoginController';
import { signInWithGoogle, signInWithFacebook } from '../../services/authService';
import Utility from '../../Utility/Utility';

const SignUp = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const [userRegister, setUserRegister] = useState({
    name: "",
    email: "",
    password: "",
    team: "",
    termsAndConditions: false
  })
  const [userRegisterError, setUserRegisterError] = useState({
    name: "",
    email: "",
    password: "",
    team: "",
    termsAndConditions: ""
  });

  const roleList = [
    { name: "coach", label: "Coach" },
    { name: "sponser", label: "Sponser" },
  ];

  const handleRegister = () => {
    console.log(userRegister);
    let valid = validateRegister();
    if (valid) {
      let data = {
        fullName: userRegister.name,
        email: userRegister.email,
        password: userRegister.password,
        role: userRegister.role,
      }
      dispatch(loaderStateTrue());
      coachRegisterApi(data).then(async (response) => {
        console.log(response);
        if (response.status) {
          setUserRegister({
            name: "",
            email: "",
            password: "",
            role: "",
            termsAndConditions: false
          })
          setUserRegisterError({
            name: "",
            email: "",
            password: "",
            role: "",
            termsAndConditions: ""
          })
          Utility.toastNotifications(response.message, 'Success', 'success');
        } else {
          setUserRegisterError({
            name: "",
            email: "",
            password: "",
            role: "",
            termsAndConditions: ""
          })
          Utility.toastNotifications(response.message, 'Error', 'error');
        }
        dispatch(loaderStateFalse());
      }).catch((error) => {
        console.log(error);
        dispatch(loaderStateFalse());
      });
    }
  }

  const handleGoogleSignIn = async () => {
    dispatch(loaderStateTrue());
    const result = await signInWithGoogle();
    dispatch(loaderStateFalse());

    if (result.success) {
      console.log('Google Sign-In successful:', result.user);
      // TODO: Send user data to your backend API and handle navigation
      // Example: await coachRegisterApi({ socialAuth: true, provider: 'google', user: result.user });
      alert(`Welcome ${result.user.displayName}! Google sign-in successful.`);
    } else {
      console.error('Google Sign-In failed:', result.error);
      alert(result.error);
    }
  }

  const handleFacebookSignIn = async () => {
    dispatch(loaderStateTrue());
    const result = await signInWithFacebook();
    dispatch(loaderStateFalse());

    if (result.success) {
      console.log('Facebook Sign-In successful:', result.user);
      // TODO: Send user data to your backend API and handle navigation
      // Example: await coachRegisterApi({ socialAuth: true, provider: 'facebook', user: result.user });
      alert(`Welcome ${result.user.displayName}! Facebook sign-in successful.`);
    } else {
      console.error('Facebook Sign-In failed:', result.error);
      alert(result.error);
    }
  }

  const validateRegister = () => {
    let valid = true;
    if (userRegister.name.trim() === "") {
      valid = false;
      setUserRegisterError({ ...userRegisterError, name: t('requiredField') });
    } else {
      setUserRegisterError({ ...userRegisterError, name: "" });
    }
    if (userRegister.email.trim() === "") {
      valid = false;
      setUserRegisterError({ ...userRegisterError, email: t('requiredField') });
    } else if (userRegister.email.trim() !== "") {
      let expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
      if (!expr.test(userRegister.email.trim())) {
        valid = false;
        setUserRegisterError({ ...userRegisterError, email: t('validEmail') });
      } else {
        setUserRegisterError({ ...userRegisterError, email: "" });
      }
    }
    if (userRegister.password.trim() === "") {
      valid = false;
      setUserRegisterError({ ...userRegisterError, password: t('requiredField') });
    } else {
      setUserRegisterError({ ...userRegisterError, password: "" });
    }
    if (!userRegister.termsAndConditions) {
      valid = false;
      Utility.toastNotifications(`Please ${t('acceptThe')} ${t('termsAndConditions')}`, 'Warning', 'warning');
    }
    return valid;
  }

  return (
    <div className="lg:p-10 px-5 pt-10 pb-5">
      <div className="flex flex-wrap gap-y-10">
        <div className="lg:w-1/2 w-full">
          <div className="h-full p-5 relative">
            <div className="rounded-xl absolute inset-0 bg-[#eaede8] overflow-hidden">
              <div className="w-[22vw] h-[17vw] rounded-[50%] bg-[#0198FF] blur-[70px] absolute -top-[1vw] right-0 -rotate-[37deg] opacity-80"></div>
              <div className="w-[30vw] h-[18vw] rounded-[50%] bg-[#FB4A4A] blur-[130px] absolute -top-[2vw] left-0 rotate-[50deg]"></div>
            </div>
            <div className="relative flex flex-col gap-y-10">
              <div className="lg:-mt-16 -mt-10">
                <img src={require("../../assets/images/star-players.png")} alt="" />
              </div>
              <div className="lg:p-5 [&_h1_strong]:bg-gradient-to-r [&_h1_strong]:from-primary-950 [&_h1_strong]:to-primary-500 [&_h1_strong]:bg-clip-text [&_h1_strong]:text-transparent space-y-5">
                <h1 className="2xl:text-6xl xl:text-5xl lg:text-4xl md:text-3xl text-2xl font-extrabold uppercase text-gray-900">
                  {t('oneTeam')},<br />{t('oneDream')}<br /><strong>{t('letsDreamTogether')}</strong>
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:w-1/2 w-full">
          <div className="rounded-xl h-full lg:px-10 relative space-y-8 flex flex-col justify-center">
            <div className="[&_h2_strong]:text-gray-400 space-y-5">
              <h2 className="xl:text-4xl lg:text-3xl md:text-2xl text-xl font-extrabold leading-[1.2] uppercase">
                {t('fillInformation')} <strong>{t('orSignUpWithSocial')}</strong>
              </h2>
            </div>

            <div className="space-y-5">
              <div>
                <select name="role" id="role" className='form-select' onChange={(e) => {
                  setUserRegister({ ...userRegister, role: e.target.value });
                  setUserRegisterError({ ...userRegisterError, role: "" });
                }}
                  value={userRegister.role}
                >
                  <option value="" disabled>{t('selectRole')}</option>
                  {roleList.map((item,index) => (
                    <option key={index} value={item.name}>{item.label}</option>
                  ))}
                </select>
              </div>
              <span className="text-red-500">{userRegisterError.role}</span>
              <div>
                <input type="text" id="name" placeholder={t('name')} className="form-control" onChange={(e) => {
                  setUserRegister({ ...userRegister, name: e.target.value })
                  setUserRegisterError({ ...userRegisterError, name: "" });
                }}
                  value={userRegister.name}
                />
              </div>
              <span className="text-red-500">{userRegisterError.name}</span>
              <div>
                <input type="email" id="email" placeholder={t('email')} className="form-control" onChange={(e) => {
                  setUserRegister({ ...userRegister, email: e.target.value });
                  setUserRegisterError({ ...userRegisterError, email: "" });
                }}
                  value={userRegister.email}
                />
              </div>
              <span className="text-red-500">{userRegisterError.email}</span>
              <div>
                <input type="password" id="password" placeholder={t('password')} className="form-control" onChange={(e) => {
                  setUserRegister({ ...userRegister, password: e.target.value })
                  setUserRegisterError({ ...userRegisterError, password: "" });
                }}
                  value={userRegister.password}
                />
              </div>
              <span className="text-red-500">{userRegisterError.password}</span>

              <div className="flex justify-between gap-5">
                <label className="relative inline-flex items-center gap-1.5 cursor-pointer">
                  <input type="checkbox" className="input-checkbox" checked={userRegister.termsAndConditions} onChange={(e) => {
                    setUserRegister({ ...userRegister, termsAndConditions: e.target.checked });
                    setUserRegisterError({ ...userRegisterError, termsAndConditions: "" });
                  }} value={userRegister.termsAndConditions} />
                  <span className="font-secondary font-medium text-gray-400">
                    {t('acceptThe')} <a href="#" className="text-gray-900 underline">{t('termsAndConditions')}</a>
                  </span>
                </label>
              </div>

              <button className="w-full btn btn-primary" onClick={handleRegister}>{t('createAccount')}</button>

              <div className="2xl:text-xl text-lg font-bold text-gray-800">{t('orSignInWith')}</div>

              <div className="space-y-3">
                <button className="w-full btn !border !border-gray-200 !inline-flex items-center gap-2" onClick={handleGoogleSignIn}>
                  <img src={require("../../assets/images/icons/google.svg")} alt="" width="24" />{t('signInWithGoogle')}
                </button>
                <button className="w-full btn !border !border-gray-200 !inline-flex items-center gap-2" onClick={handleFacebookSignIn}>
                  <img src={require("../../assets/images/icons/facebook-fill.svg")} alt="Facebook" width="24" className="fb-color" /> {t('signInWithFacebook')}
                </button>
              </div>

              <p className="mt-2 font-secondary font-semibold">
                {t('alreadyHaveAccount')}{' '}
                <Link to="../login" className="text-primary-500 font-medium hover:underline">
                  {t('signInLink')}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
